import { signInWithPopup } from "firebase/auth";
import React, { useState } from "react";
import { auth, googleAuthProvider } from "../firebase/Firebase";
import GoogleLogo from "../../../images/googleLogo.svg";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../../constants/Api";
import { useDispatch, useSelector } from "react-redux";
import { setAppUserName } from "../../../slices/LayoutSlice";
import { setLoader } from "../../../slices/LoaderSlice";
import { EmailButtonClick } from '../../../utils/Analytics';

function Google({source}) {
  const [accessToken, setAccessToken] = useState("");
  const [tockenResponse, setTockenResponse] = useState([]);

  const dispatch = useDispatch()
  const navigate = useNavigate();

  const eventRedirectLink = useSelector((store) => store?.layout?.eventRedirect);

  const handelGoogleLogin = async () => {
    EmailButtonClick();
    // Reset the loader state before starting the login attempt
    dispatch(setLoader(true));
    // console.log("log in innnnn=============")
  
    // Clean up any existing event listeners before adding a new one
    const handlePopupDismiss = (e) => {
      if (e.target !== window) return; // Ensure the correct dismissal detection
      dispatch(setLoader(false)); // Stop loader on dismissal
      window.removeEventListener("focus", handlePopupDismiss); // Clean up event listener
      // console.log("Google login popup dismissed.");
      // console.log("handlePopupDismiss==================");
    };
  
    // Attach the event listener for popup dismissal
    window.addEventListener("focus", handlePopupDismiss);
  
    try {
      const result = await signInWithPopup(auth, googleAuthProvider);
      window.removeEventListener("focus", handlePopupDismiss); // Clean up on success
      console.log(result);
  
      localStorage.setItem("guest_email", result.user.email);
      dispatch(setAppUserName(result?.user?.displayName));
      navigate("../hotel-list", {
        state: {
          source: eventRedirectLink,
        },
      });
      console.log("result.user.email========",result.user.email);
      if(result.user?.email){
        dispatch(setLoader(false)); // Stop loader after successful login
      }
    } catch (e) {
      window.removeEventListener("focus", handlePopupDismiss); // Clean up on error
      console.error("Error during Google login:", e);
      // dispatch(setLoader(false)); // Stop loader on error
    }
  };
  

  

  return (
    <div>
      <button className="google-btn" onClick={handelGoogleLogin}>
        <span>
          <img src={GoogleLogo} alt="" />
        </span>
        <span>Google</span>
      </button>
    </div>
  );
}

export default Google;
